import { render, staticRenderFns } from "./HotelInfo.vue?vue&type=template&id=7981e0de"
import script from "./HotelInfo.vue?vue&type=script&lang=js"
export * from "./HotelInfo.vue?vue&type=script&lang=js"
import style0 from "./HotelInfo.vue?vue&type=style&index=0&id=7981e0de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports